module.exports = __webpack_public_path__ + "media/components/HowItWorks/components/ReadyToFind/key-4177676a6c87d7ecd6801ca58fa25e6f.jpg";